import { z } from 'zod'
import { iconTypeSchema } from '@/types/schema/icon-type-schema'
import { platformCodeSchema } from '@/types/schema/platform/platform-code-schema'
import { platformShortcodeSchema } from '@/types/schema/platform/platform-shortcode-schema'
import { platformTypeSchema } from '@/types/schema/platform/platform-type-schema'
import { PlatformType } from '@/types/schema/report-schema'

const PlatformSchema = z.object({
  code: platformCodeSchema,
  shortcode: platformShortcodeSchema,
  title: z.string(),
  type: z.optional(platformTypeSchema),
  icon: iconTypeSchema.optional(),
  inactiveIcon: iconTypeSchema.optional(),
})

export type Platform = z.infer<typeof PlatformSchema>

export const platforms: Platform[] = [
  {
    code: platformCodeSchema.enum.all,
    shortcode: platformShortcodeSchema.enum.all,
    title: 'All',
  },
  {
    type: PlatformType.Other,
    code: platformCodeSchema.enum.other,
    shortcode: platformShortcodeSchema.enum.other,
    title: 'Other',
  },
  {
    code: platformCodeSchema.enum.blog,
    shortcode: platformShortcodeSchema.enum.blog,
    title: 'Blog',
  },
  {
    code: platformCodeSchema.enum.tiktok,
    shortcode: platformShortcodeSchema.enum.tiktok,
    title: 'TikTok',
    type: PlatformType.TikTok,
  },
  {
    code: platformCodeSchema.enum.facebook,
    shortcode: platformShortcodeSchema.enum.fb,
    title: 'Facebook',
    type: PlatformType.Facebook,
    icon: 'brand-facebook-filled',
    inactiveIcon: 'brand-facebook-inactive-filled',
  },
  {
    code: platformCodeSchema.enum.instagram,
    shortcode: platformShortcodeSchema.enum.ig,
    title: 'Instagram',
    type: PlatformType.Instagram,
    icon: 'brand-instagram-filled',
    inactiveIcon: 'brand-instagram-inactive-filled',
  },
  {
    code: platformCodeSchema.enum.youtube,
    shortcode: platformShortcodeSchema.enum.yt,
    title: 'YouTube',
    type: PlatformType.YouTube,
    icon: 'brand-youtube-filled',
    inactiveIcon: 'brand-youtube-inactive-filled',
  },
  {
    code: platformCodeSchema.enum.twitter,
    shortcode: platformShortcodeSchema.enum.twitter,
    title: 'Twitter',
    type: PlatformType.Twitter,
  },
]
